import { render } from "./CarrouselAboutUs.vue?vue&type=template&id=362abeec&scoped=true&lang=html"
import script from "./CarrouselAboutUs.vue?vue&type=script&lang=js"
export * from "./CarrouselAboutUs.vue?vue&type=script&lang=js"

import "./CarrouselAboutUs.vue?vue&type=style&index=0&id=362abeec&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362abeec"]])

export default __exports__